import { Measurement } from '../../components/measurement';
import { PreventativeMaintenanceTab } from './pm';

export class AdjustDueOdometerWindow {
    private windowManager;
    private parent;
    private vehicleDueOdometerKm!: number;
    private pmInstanceId!: string;
    private assetId!: string;
    private formObj!: dhtmlXForm;
    private assetName!: string;
    private pmName!: string;

    constructor(manager: dhtmlXWindows, parent: PreventativeMaintenanceTab) {
        this.windowManager = manager;
        this.parent = parent;
    }

    setAssetName(assetName: string) {
        this.assetName = assetName;
    }

    setPmName(pmName: string) {
        this.pmName = pmName;
    }

    setVehicleDueOdometerKm(vehicleDueOdometerKm: number) {
        this.vehicleDueOdometerKm = vehicleDueOdometerKm;
    }

    setPmInstanceId(pmInstanceId: string) {
        this.pmInstanceId = pmInstanceId;
    }

    setAssetId(assetId: string) {
        this.assetId = assetId;
    }

    show() {
        const form = [
            {
                type: 'settings',
                position: 'label-left',
                labelWidth: 115,
                inputWidth: 200,
            },
            {
                name: 'current_due_odometer',
                type: 'input',
                label: 'Current Due @:',
                value: '',
                labelAlign: 'left',
                offsetLeft: 15,
                hidden: false,
                tooltip: 'Current Due Odometer',
                disabled: true,
                checked: false,
            },
            {
                name: 'adjusted_due_odometer',
                type: 'input',
                label: 'Adjusted Due @:',
                value: '',
                labelAlign: 'left',
                offsetLeft: 15,
                hidden: false,
                tooltip: 'Enter the new due odometer value.',
                checked: false,
            },
            {
                type: 'container',
                name: 'buttonSpacer',
                label: '',
                inputWidth: 0,
            },
        ];

        const window = this.windowManager.createWindow('pm_adjust_due_odometer', 30, 30, 400, 400);
        window.setText('Adjust the Due Odometer');

        window.attachHTMLString(`
    <div style="padding: 22px; box-sizing: border-box;">

        <div style="
            padding: 0px 20px;
            margin-bottom: 2px;
            background: #f3f6f9;
            border: 1px solid #dce5ed;
            border-left: 4px solid #173653;
            border-radius: 6px;
            color: #46566a;
            font: 13px/1.5 Arial, sans-serif;
        ">
             <table style="
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 14px;
    font-family: Arial, sans-serif;
    font-size: 13px;
    color: #334155;
">
    <tr>
        <td style="
            width: 75px;
            padding: 5px 10px 5px 0;
            color: #64748b;
            font-weight: 600;
            white-space: nowrap;
        ">Vehicle</td>
        <td style="padding: 5px 0; font-weight: 600;">
            ${this.assetName}
        </td>
    </tr>
    <tr>
        <td style="
            padding: 5px 10px 5px 0;
            color: #64748b;
            font-weight: 600;
            white-space: nowrap;
        ">PM</td>
        <td style="padding: 5px 0; font-weight: 600;">
            ${this.pmName}
        </td>
    </tr>
</table>
        </div>

        <div id="odometerFormContainer"></div>

        <div style="
            display: block;
            clear: both;
            width: 100%;
            margin-top: 25px;
            padding-top: 15px;
            border-top: 1px solid #e1e7ef;
            text-align: right;
            box-sizing: border-box;
        ">
            <button id="submitOdometer" type="button" style="
                display: inline-block;
                position: relative;
                padding: 11px 24px;
                background: #173653;
                color: #ffffff;
                border: none;
                border-radius: 6px;
                font: 600 13px Arial, sans-serif;
                cursor: pointer;
                box-shadow: 0 2px 5px rgba(23,54,83,0.18);
                "
                onmouseover="this.style.background='#28a745'"
                onmouseout="this.style.background='#173653'"
            >
                &#10003;&nbsp; Update Due Odometer
            </button>
        </div>
    </div>
`);

        this.formObj = new dhtmlXForm('odometerFormContainer', form as unknown as IdhtmlXFormConfig[]);

        const miles = Measurement.km2miles(this.vehicleDueOdometerKm);
        this.formObj.setItemValue('current_due_odometer', miles);
        this.formObj.setItemValue('adjusted_due_odometer', miles);

        const container = document.getElementById('odometerFormContainer');
        if (container) {
            container.querySelectorAll('input').forEach((input) => {
                input.style.boxSizing = 'border-box';
                input.style.height = '34px';
                input.style.padding = '6px 10px';
                input.style.border = '1px solid #cbd5e1';
                input.style.borderRadius = '5px';
                input.style.fontSize = '13px';
                input.style.backgroundColor = '#ffffff';
                input.style.color = '#243447';
            });

            container.querySelectorAll('label').forEach((label) => {
                label.style.fontSize = '13px';
                label.style.fontWeight = '600';
                label.style.color = '#475569';
            });
        }

        const submitButton = document.getElementById('submitOdometer');
        if (submitButton) {
            submitButton.addEventListener('click', () => {
                const newOdometerValueMiles = parseFloat(this.formObj.getItemValue('adjusted_due_odometer'));
                const newOdometerValueKm = Measurement.miles2km(newOdometerValueMiles);
                console.log('New Odometer Value (Miles):', newOdometerValueMiles);
                console.log('New Odometer Value (Km):', newOdometerValueKm);

                this.parent.service.setVehicleDueAtOdometer(this.pmInstanceId, newOdometerValueKm).then((_response) => {
                    this.parent.loadData(true);
                });
            });
        }
    }
}
